var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.status)?_c('div',{staticClass:"px-2 rounded-lg p-1 bg-opacity-10",class:_vm.colourClasses()},[_vm._v(_vm._s(_vm.status))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }